import type { PublicationCode } from '@/scopes/common/domain/types'

export type FilterComponent =
  'DestinationFilter'
  | 'DepartureDateFilter'
  | 'DurationFilter'
  | 'ParticipantsFilter'
  | 'TransportTypeFilter'
  | 'DepartureAirportFilter'

const getFilterComponents: Record<string, FilterComponent[]> = {
  SZ: ['DestinationFilter', 'DepartureDateFilter', 'DurationFilter', 'ParticipantsFilter'],
  WG: ['DestinationFilter', 'DepartureDateFilter', 'TransportTypeFilter', 'DurationFilter', 'ParticipantsFilter'],
  BZ: ['DestinationFilter', 'DepartureDateFilter', 'DurationFilter', 'ParticipantsFilter'],
  BW: ['DestinationFilter', 'DepartureDateFilter', 'TransportTypeFilter', 'DurationFilter', 'ParticipantsFilter'],
  FS: ['DestinationFilter', 'DepartureDateFilter', 'DurationFilter', 'ParticipantsFilter'],
  FH: ['DestinationFilter', 'DepartureDateFilter', 'TransportTypeFilter', 'DurationFilter', 'ParticipantsFilter'],
  FZ: ['DestinationFilter', 'DepartureDateFilter', 'DurationFilter', 'ParticipantsFilter'],
  FW: ['DestinationFilter', 'DepartureDateFilter', 'DurationFilter', 'ParticipantsFilter'],
  DW: ['DestinationFilter', 'DepartureDateFilter', 'TransportTypeFilter', 'DurationFilter', 'ParticipantsFilter'],
  UW: ['DestinationFilter', 'DepartureDateFilter', 'TransportTypeFilter', 'DurationFilter', 'ParticipantsFilter'],
  QZ: ['DestinationFilter', 'DepartureDateFilter', 'DepartureAirportFilter', 'DurationFilter', 'ParticipantsFilter'],
  QW: ['DestinationFilter', 'DepartureDateFilter', 'DurationFilter', 'ParticipantsFilter'],
  KZ: ['DestinationFilter', 'DepartureDateFilter', 'DurationFilter', 'ParticipantsFilter'],
  KW: ['DestinationFilter', 'DepartureDateFilter', 'TransportTypeFilter', 'DurationFilter', 'ParticipantsFilter'],
}

export function getFiltersForQuickSearch(publicationCode: PublicationCode): FilterComponent[] {
  return getFilterComponents[publicationCode]
}
